import React, { useState, useEffect } from "react";
import { TextField } from "@material-ui/core";

const NumberInput = ({ id = "number-input", name = "number-input", value = 0, decimalScale = 2, textAlign = 'left', readOnly = false, onChange = () => {}, disabled = false }) => {
  const [inputValue, setInputValue] = useState(value.toString());
  const [isFocused, setIsFocused] = useState(false);

  // formatter ตามจำนวนทศนิยมที่กำหนด
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimalScale,
    maximumFractionDigits: decimalScale,
  });

  useEffect(() => {
    if (value !== null && value !== undefined && !isNaN(value)) {
      setInputValue(formatter.format(value));
    }
  }, [value, decimalScale]);

  const handleFocus = (e) => {
    setIsFocused(true);
    // ถ้าค่าเป็น 0 ให้ clear ทิ้ง เพื่อให้พิมพ์เลขใหม่ได้เลย
    const num = parseFloat(inputValue.replace(/,/g, ""));
    if (num === 0) {
      setInputValue("");
      e.target.select(); // select all เพื่อให้พิมพ์ทับได้เลย
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;
    // อนุญาตให้เป็นค่าว่าง หรือ ตัวเลขและทศนิยม
    if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
      setInputValue(val);
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    let num = parseFloat(inputValue.replace(/,/g, ""));
    if (!isNaN(num)) {
      setInputValue(formatter.format(num));
      if (onChange) onChange(num);  //เช็คก่อนเรียก
    } else {
      setInputValue(formatter.format(0));
      if (onChange) onChange(0);    //เช็คก่อนเรียก
    }
  };

  return (
    <TextField
      id={id}
      name={name}
      size="small"
      variant="outlined"
      fullWidth
      right
      value={inputValue}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      inputProps={{
        style: { textAlign: textAlign },
        readOnly: readOnly
      }}
    />
  );
};

export default NumberInput;